import React from 'react';
import './instructor.css';
import {Grid, Button, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom'

const InstructorCard = ({ instructores, strings, onShowModalInstructor }) => {
    
    {/*<Link to={"/instructor/"+inst.id} ><Button primary size="small">{strings?strings["MasInformacion"]:""}</Button></Link> */}
    
    return (
        <div class="row"  >
         
     {instructores.map(inst =>
                <div  >
                    <div class="team-block">
                        <div class="team-img">
                            <Image  src={inst.img} size='medium' fluid circular>
                            </Image>
                            <div class="team-content">
                                <h4 class="text-white mb40">{inst.name}</h4>
                                 - {inst.titulo} 
                            </div>
                            <div class="overlay">
                                <div class="text-inst">
                                    <h4 class="mb0 text-white">{inst.name}</h4>
                                    <p class="mb30 team-meta">- {inst.titulo}</p>
                                    <Button primary onClick={()=>onShowModalInstructor(inst.id)} size="small">{strings?strings["MasInformacion"]:""} </Button>   
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
        )}
           </div> 
     );
                 
 
    
};

export default InstructorCard;
